import React from 'react';
import habeebImg from '../assets/habeeb.png';
import buildingImg from '../assets/building.png';

const Landing = () => {
  return (
    <>
      
{/*  Top Navigation (Fixed)  */}

{/*  Side NavBar (Fixed Floating Right)  */}

{/*  Hero Section  */}
<header className="relative min-h-screen flex items-center justify-start pt-20 overflow-hidden">
{/*  Background Image with Overlay  */}
<div className="absolute inset-0 w-full h-full z-0">
<img alt="Hero architectural building at dusk" className="w-full h-full object-cover object-center" src={buildingImg} />
<div className="absolute inset-0 bg-gradient-to-r from-primary-container/90 via-primary-container/60 to-transparent"></div>
</div>
<div className="relative z-10 w-full max-w-container-max mx-auto px-6 md:px-margin-desktop pt-20 pb-32">
<div className="max-w-3xl opacity-0 animate-fade-in">
<div className="flex items-center gap-3 mb-6">
<span className="material-symbols-outlined text-secondary text-[16px]">diamond</span>
<span className="font-label-caps text-label-caps text-secondary tracking-[0.3em]">A LANDMARK THAT DEFINES</span>
</div>
<h1 className="font-display-lg text-display-lg text-white mb-8 leading-tight">
                    VISION.<br />TRUST.<br /><span className="text-secondary font-medium">EXCELLENCE.</span>
</h1>
<p className="font-body-md text-body-md text-white-variant mb-12 max-w-xl opacity-0 animate-fade-in delay-100">
                    HBB0011 Realty Realtors Pvt. Ltd. is committed to creating iconic spaces that blend architectural brilliance with sustainable living, setting new benchmarks in the ultra-luxury real estate sector.
                </p>
<div className="flex flex-wrap items-center gap-6 opacity-0 animate-fade-in delay-200">
<a className="btn-primary font-label-caps text-label-caps px-8 py-4 flex items-center gap-2 group" href="#projects">
                        EXPLORE PROJECTS
                        <span className="material-symbols-outlined text-[18px] group-hover:translate-x-1 transition-transform">arrow_forward</span>
</a>
<a className="font-label-caps text-label-caps text-white border border-outline-variant px-8 py-4 flex items-center gap-2 hover:border-secondary hover:text-secondary transition-colors group bg-transparent" href="#contact">
                        GET IN TOUCH
                        <span className="material-symbols-outlined text-[18px] group-hover:translate-x-1 transition-transform">arrow_forward</span>
</a>
</div>
</div>
</div>
{/*  Floating Statistics Bar  */}
<div className="absolute bottom-0 left-0 w-full glass-panel z-20 border-t border-b-0 border-l-0 border-r-0">
<div className="max-w-container-max mx-auto px-6 lg:px-8 py-6">
<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 divide-x divide-outline-variant/30">
<div className="flex flex-col items-center justify-center text-center px-4">
<span className="font-headline-lg text-[28px] text-secondary font-light mb-1">10+</span>
<span className="font-label-caps text-[10px] text-white-variant tracking-[0.2em]">YEARS</span>
</div>
<div className="flex flex-col items-center justify-center text-center px-4">
<span className="font-headline-lg text-[28px] text-secondary font-light mb-1">25+</span>
<span className="font-label-caps text-[10px] text-white-variant tracking-[0.2em]">PROJECTS</span>
</div>
<div className="flex flex-col items-center justify-center text-center px-4">
<span className="font-headline-lg text-[28px] text-secondary font-light mb-1">5000+</span>
<span className="font-label-caps text-[10px] text-white-variant tracking-[0.2em]">CUSTOMERS</span>
</div>
<div className="flex flex-col items-center justify-center text-center px-4">
<span className="font-headline-lg text-[28px] text-secondary font-light mb-1">5+</span>
<span className="font-label-caps text-[10px] text-white-variant tracking-[0.2em]">LOCATIONS</span>
</div>
<div className="flex flex-col items-center justify-center text-center px-4 col-span-2 md:col-span-1 lg:col-span-1">
<span className="material-symbols-outlined text-secondary text-[28px] mb-2 font-light">verified</span>
<span className="font-label-caps text-[10px] text-white-variant tracking-[0.2em]">QUALITY TRUST</span>
</div>
</div>
</div>
</div>
<aside className="hidden xl:flex absolute right-8 top-1/2 -translate-y-1/2 rounded-xl bg-surface-container/40 backdrop-blur-md border border-outline-variant/30 shadow-xl z-40 flex-col items-center py-8 gap-6 w-20">
<a className="group relative flex justify-center w-full py-4 text-white-variant hover:bg-surface-container-highest transition-all duration-300 cursor-pointer" href="#residential">
<span className="material-symbols-outlined group-hover:text-secondary transition-colors">apartment</span>
<div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-surface-container border border-outline-variant px-4 py-2 rounded font-label-caps text-[10px] text-white opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap shadow-lg">RESIDENTIAL</div>
</a>
<a className="group relative flex justify-center w-full py-4 text-white-variant hover:bg-surface-container-highest transition-all duration-300 cursor-pointer" href="#commercial">
<span className="material-symbols-outlined group-hover:text-secondary transition-colors">business_center</span>
<div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-surface-container border border-outline-variant px-4 py-2 rounded font-label-caps text-[10px] text-white opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap shadow-lg">COMMERCIAL</div>
</a>
<a className="group relative flex justify-center w-full py-4 text-white-variant hover:bg-surface-container-highest transition-all duration-300 cursor-pointer" href="#investments">
<span className="material-symbols-outlined group-hover:text-secondary transition-colors">payments</span>
<div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-surface-container border border-outline-variant px-4 py-2 rounded font-label-caps text-[10px] text-white opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap shadow-lg">INVESTMENTS</div>
</a>
<a className="group relative flex justify-center w-full py-4 text-white-variant hover:bg-surface-container-highest transition-all duration-300 cursor-pointer mt-4 border-t border-outline-variant" href="#enquire">
<span className="material-symbols-outlined text-secondary">headset_mic</span>
<div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-secondary text-on-secondary px-4 py-2 rounded font-label-caps text-[10px] font-bold opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap shadow-lg">ENQUIRE NOW</div>
</a>
</aside></header>
{/*  About Us & Projects Grid Section  */}
<section className="py-32 px-6 md:px-margin-desktop relative" id="about">
<div className="max-w-container-max mx-auto">
<div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
{/*  Left: About Content (1/3)  */}
<div className="lg:col-span-4 flex flex-col justify-center">
<h3 className="font-label-caps text-label-caps text-secondary tracking-[0.3em] mb-6">ABOUT US</h3>
<h2 className="font-headline-lg text-[36px] md:text-[42px] leading-tight text-on-surface font-light mb-8">
                        BUILDING <span className="font-medium">TRUST.</span><br />
                        CREATING <span className="font-medium">LANDMARKS.</span>
</h2>
<div className="w-12 h-px bg-secondary mb-8"></div>
<p className="font-body-md text-body-md text-on-surface-variant mb-6">
                        At HBB0011 Realty, we don't just construct buildings; we engineer lifestyles. Our architectural philosophy centers on minimal intervention with maximum impact, ensuring every development harmonizes with its environment while providing unparalleled luxury.
                    </p>
<p className="font-body-md text-body-md text-on-surface-variant mb-10">
                        With a decade of unwavering commitment to quality and transparency, our portfolio stands as a testament to visionary design and meticulous execution in the ultra-luxury segment.
                    </p>
<a className="group flex items-center gap-3 w-max" href="#about-detailed">
<span className="font-label-caps text-label-caps text-secondary">READ OUR STORY</span>
<div className="w-8 h-px bg-secondary group-hover:w-16 transition-all duration-300"></div>
</a>
</div>
{/*  Right: Projects Bento Grid (2/3)  */}
<div className="lg:col-span-8">
<div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-full">
{/*  Grid Item 1  */}
<a className="group relative overflow-hidden h-[300px] md:h-[400px] border border-outline-variant/30 flex items-end" href="#residential">
<div className="absolute inset-0 bg-surface-container-low" data-alt="A striking digital installation art piece featuring glowing, generative geometric shapes suspended in a vast, minimalist gallery space. The room is illuminated by high-key, soft white lighting that creates a bright, modern light-mode aesthetic. The artwork relies on a sophisticated palette of deep blacks and pristine whites, punctuated by intense accents of vibrant red. The mood is serene yet technologically advanced." style={{backgroundImage: `url(${buildingImg})`}}>
<img className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-alt="A striking digital installation art piece featuring glowing, generative geometric shapes suspended in a vast, minimalist gallery space. The room is illuminated by high-key, soft white lighting that creates a bright, modern light-mode aesthetic. The artwork relies on a sophisticated palette of deep blacks and pristine whites, punctuated by intense accents of vibrant red. The mood is serene yet technologically advanced." src={buildingImg} />
</div>
<div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
<div className="relative z-10 p-8 w-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
<span className="material-symbols-outlined text-secondary mb-3">apartment</span>
<h3 className="font-label-caps text-[14px] text-on-surface tracking-widest mb-2 flex items-center justify-between">
                                    RESIDENTIAL PROJECTS
                                    <span className="material-symbols-outlined text-[18px] opacity-0 group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0 transition-all duration-300">arrow_forward</span>
</h3>
<div className="w-0 h-px bg-secondary group-hover:w-full transition-all duration-500 ease-in-out mt-4"></div>
</div>
</a>
{/*  Grid Item 2  */}
<a className="group relative overflow-hidden h-[300px] md:h-[400px] border border-outline-variant/30 flex items-end" href="#commercial">
<div className="absolute inset-0 bg-surface-container-low" data-alt="A striking digital installation art piece featuring glowing, generative geometric shapes suspended in a vast, minimalist gallery space. The room is illuminated by high-key, soft white lighting that creates a bright, modern light-mode aesthetic. The artwork relies on a sophisticated palette of deep blacks and pristine whites, punctuated by intense accents of vibrant red. The mood is serene yet technologically advanced." style={{backgroundImage: `url(${buildingImg})`}}>
<img className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-alt="A striking digital installation art piece featuring glowing, generative geometric shapes suspended in a vast, minimalist gallery space. The room is illuminated by high-key, soft white lighting that creates a bright, modern light-mode aesthetic. The artwork relies on a sophisticated palette of deep blacks and pristine whites, punctuated by intense accents of vibrant red. The mood is serene yet technologically advanced." src={buildingImg} />
</div>
<div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
<div className="relative z-10 p-8 w-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
<span className="material-symbols-outlined text-secondary mb-3">business_center</span>
<h3 className="font-label-caps text-[14px] text-on-surface tracking-widest mb-2 flex items-center justify-between">
                                    COMMERCIAL SPACES
                                    <span className="material-symbols-outlined text-[18px] opacity-0 group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0 transition-all duration-300">arrow_forward</span>
</h3>
<div className="w-0 h-px bg-secondary group-hover:w-full transition-all duration-500 ease-in-out mt-4"></div>
</div>
</a>
</div>
</div>
</div>
</div>
</section>
{/*  Footer  */}

{/*  Script for Navbar scroll effect  */}






{/*  Founder Thank You Section  */}
<section className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop py-24 mb-12 border-t border-outline-variant/20">
  <div className="flex flex-col md:flex-row items-center gap-12">
    <div className="w-full md:w-1/3">
      <div className="aspect-[3/4] rounded-xl overflow-hidden border border-secondary/30 relative group">
        <img 
          src={habeebImg} 
          alt="Habeeb Rahiman M" 
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
      />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-container via-transparent to-transparent opacity-60"></div>
      </div>
    </div>
    <div className="w-full md:w-2/3">
      <h2 className="font-headline-lg text-headline-lg md:text-5xl font-light mb-6">
        THANK <span className="font-medium text-secondary">YOU</span>
      </h2>
      <div className="w-24 h-px bg-secondary mb-8"></div>
      <p className="font-body-md text-body-md text-on-surface-variant mb-8 leading-relaxed max-w-2xl">
        Thank you for choosing HBB0011 Realty. We are committed to turning your vision into reality. Your trust and partnership drive our continued pursuit of excellence and innovation in luxury real estate. Let's build the future together.
      </p>
      <div className="mt-4">
        <div className="inline-block relative mb-2">
          <span className="text-xl sm:text-2xl font-sans font-bold text-transparent bg-clip-text bg-gradient-to-r from-secondary to-yellow-200 uppercase tracking-widest relative z-10">HABEEB RAHIMAN M</span>
          <div className="absolute -bottom-1 left-0 w-1/3 h-[2px] bg-secondary"></div>
        </div>
        <div className="text-on-surface-variant text-[10px] font-bold uppercase tracking-widest">Founder & CEO</div>
      </div>
    </div>
  </div>
</section>
    </>
  );
};

export default Landing;
